import React, { Fragment, useEffect } from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import RightSidebar from 'components/right-sidebar';
import { ReactComponent as BrandDetailsIcon } from 'assets/icons/brand-details.svg';
import { ReactComponent as OpeningTimeIcon } from 'assets/icons/opening-time.svg';
import { ReactComponent as MetadataIcon } from 'assets/icons/metadata.svg';

const EditShopContent = () => {
  const { shop_id } = useParams();

  const navigate = useNavigate();

  const { setRightSection } = useDashboardContext();

  if (!shop_id) {
    navigate(-1);
    return null;
  }

  const EditShopDetailsNav = [
    {
      title: 'Shop details',
      link: `shop/${shop_id}/details`,
      Icon: BrandDetailsIcon
    },

    {
      title: 'Shop Images',
      link: `shop/${shop_id}/images`,
      Icon: OpeningTimeIcon
    },
    {
      title: 'Shop Opening Time',
      link: `shop/${shop_id}/opening-time`,
      Icon: MetadataIcon
    },
    {
      title: 'Shop Polygon',
      link: `shop/${shop_id}/polygon`,
      Icon: MetadataIcon
    },
    {
      title: 'Shop metadata',
      link: `shop/${shop_id}/metadata`,
      Icon: MetadataIcon
    },
    {
      title: 'Shop fees',
      link: `shop/${shop_id}/fees`,
      Icon: MetadataIcon
    }
  ];

  useEffect(() => {
    setRightSection(<RightSidebar list={EditShopDetailsNav} />);

    return () => {
      setRightSection(null);
    };
  }, []);

  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};

export default EditShopContent;
